import enUS from './en-US';
import esCL from './es-CL';

export default {
  'en-US': enUS,
  'es-CL': esCL
};
